import { app } from 'core';
import { EmptyCart as EmptyCartTemplate } from 'ui/components';

export const EmptyCart = () => {
  const { closeCart } = app.commands.useAppCommand();

  return <EmptyCartTemplate onClick={closeCart} />;
};
